import { useState, useCallback } from 'react';
import axios from 'axios';
import { FilterOptions } from '../types';
import { API_BASE } from '../constants';

export interface FilterOptionsState {
  filterOptions: FilterOptions;
  fetchFilterOptions: () => Promise<void>;
}

const EMPTY: FilterOptions = { categories: [], managers: [] };

/**
 * Загружает уникальные значения для дропдаунов фильтров.
 * Для пользователя: только категории и менеджеры одной аптеки.
 */
export function useFilterOptions(pharmacyGuid: string): FilterOptionsState {
  const [filterOptions, setFilterOptions] = useState<FilterOptions>(EMPTY);

  const fetchFilterOptions = useCallback(async () => {
    if (!pharmacyGuid) return;
    try {
      const resp = await axios.get(`${API_BASE}/journal-user/filter-options`, {
        params: { pharmacyGuid },
      });
      if (resp.data?.success) {
        setFilterOptions(resp.data.data || EMPTY);
      }
    } catch (e) {
      console.error('FilterOptions fetch error:', e);
    }
  }, [pharmacyGuid]);

  return { filterOptions, fetchFilterOptions };
}
